import { Injectable } from '@angular/core';
import { userI } from "../shared/models/user.interface";
import { AngularFireAuth } from "@angular/fire/auth";
import { Observable } from "rxjs";
import { fileI } from '../shared/models/file.interface';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize, map } from 'rxjs/operators';
import { AngularFirestore } from "@angular/fire/firestore";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public userData:Observable<firebase.User>;

  private filePath:string;

  constructor(private afauth:AngularFireAuth, private storage:AngularFireStorage, private db:AngularFirestore) 
  { 
    this.userData = afauth.authState;
  }

  loginByEmail(user:userI)
  {
    const {email, password} = user;
    return this.afauth.signInWithEmailAndPassword(email, password);
  }


  getInfoUser()
  {
  
     this.db.collection("users").get().subscribe(res=>
      {
        let usuarios = res;
        this.userData.subscribe(res=>
          {
            let uid = res.uid
            usuarios.forEach((doc)=>
            {
              //console.log(doc.data());  
              if(doc.data().uid == uid)
              {
                console.log(doc.data().name);
                return doc.data().name;
              }
            })
            
          })
        
       
        
      })
      
  }





  visitantes(pagina)
  {
    let visita:number;
    let visitaNoLog:number;
    let respuesta: any;


      
      this.db.collection('cursos').doc(pagina).valueChanges().subscribe(res=>
        {
          respuesta = res
          //console.log(respuesta);
          if(respuesta == undefined || respuesta == null)
          {
            this.db.collection('cursos').doc(pagina).set(
              {
                vistas: 0,
              }
            )
            respuesta.vistas = 0;

          }
          else
          {
            visita = respuesta.vistas;
          }
         
          
        }) 

      setTimeout(() => 
      {      
        //console.log("visitantes", visita);       
        
        //funcion que recive una pagina especifica y guarda en db 

        this.db.collection('cursos').doc(pagina).update(
          {
            vistas:visita +1
          })//fin update
      },
        5000);//fin timeout 
      
  }




  verInfo()
  {
    //aca lo que hago es tomar el uid de el usuario actual y lo comparamos con el de la db
    //this.db.collection("users").doc()

    //********PELIGO**********************************************
    

    return new Promise<boolean>((resolve)=>
    {
      
      
      this.userData.subscribe(res=>
        {
          
          if(res === null)
          {
            resolve(false);
          }
          else
          {
              
            this.db.collection("users").doc(res.uid).get().subscribe(res=>
              {
                //console.log(res.exists);
                
                  const datos = res.data();
                  
                  if(datos.tipo != "usuario")
                  {
                    resolve(true);
                  }
                  else
                  {
                    resolve(false);
                  }
    
              },err=>
              {
                  console.log(err);
                  
                  resolve(false)
              }
              )
          }
        
        },err=>
          {
            console.log(err);
            resolve(false);
          }
        )
    })

  }

  registerUser(name: string, email: string, password: string) {
    return new Promise((resolve, reject)=>
    {
      this.afauth.createUserWithEmailAndPassword(email, password).then(res=>
        {
          const uid = res.user.uid;
          //console.log(uid);
          this.db.collection("users").doc(uid).set(
            {
              email:email,
              name:name,
              uid: uid,
              tipo:"usuario"
            }
          )
          resolve(res);
        }),
        err=>
        {
          reject(err);
        }
    });
  } 


  logOut()
  {
    this.afauth.signOut();
  }

  preSaveUserProfile(user:userI, image ?:fileI)
  {
    if(image)
    {
      this.uploadImage(user, image);
    }
    else
    {
      this.saveUserProfile(user);
    }
  }

  private saveUserProfile(user:userI)
  {
    /*  this.afauth.auth.currentUser.uploadProfile({
       displayName: user.displayName,
       photoURL:user.foto
     }).then(()=>console.log("Editado"))
     .catch(err=>console.log(err)); */
  }

  private uploadImage(user:userI, image:fileI)
  {
    this.filePath = `images/${image.name}`;
    const fileRef = this.storage.ref(this.filePath);

    const task = this.storage.upload(this.filePath,image);
    task.snapshotChanges().pipe(
      finalize(()=>
      {
        fileRef.getDownloadURL().subscribe(urlImage=>
          {
            user.foto = urlImage;
            this.saveUserProfile(user);
          })
      })
    ).subscribe();
  }
}
